import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import { Col, Form, Row, Spin, Typography } from "antd";
import moment from "moment";

import SelectSingle from "components/inputs/selectSearchSingle";

import AppButton from "../../../components/button";
import ModalForm from "../../../components/forms/components/modalForm";
import AppSelect from "../../../components/inputs/select";
import {
  ADDRESS_STATUS,
  CHANNEL_NAME,
  CHANNEL_PROVIDER,
  CHANNEL_STATUS,
} from "../../../constants/appConstant";
import { AuthInfo } from "../../../stores/slices/auth";
import { doGetAllChannel } from "../../../stores/slices/channel";
import {
  doGetAddressAvailableList,
  doUpdateAddressStatus,
  numOfEls,
  setServiceId,
} from "../../../stores/slices/numbers";
import {
  doGetSubscriptionDetail,
  doGetUseSubscription,
  getCurrentSubscription,
} from "../../../stores/slices/subscriptions";
import { WorkspaceInfo } from "../../../stores/slices/workspace";

import styles from "../../../components/styles.module.scss";

const NumberOperatorAssignForm = props => {
  const { onCancel, onSuccess } = props;
  const formRef = React.useRef(null);
  const voiceSettingRef = React.useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const authInfo = useSelector(AuthInfo);
  const noOfElements = useSelector(numOfEls);
  const [availableList, setAvailableList] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  const currentSubscription = useSelector(getCurrentSubscription);
  const [subscriptionPackage, setSubscriptionPackage] = useState({});
  const [objectPrice, setObjectPrice] = useState({});
  const [isShowConfirmPopup, setIsShowConfirmPopup] = useState(false);
  const workspaceDetail = useSelector(WorkspaceInfo);
  const [channelLoading, setChannelLoading] = useState(true);
  const [channelList, setChannelList] = useState(null);
  // const [channelSelected, setChannelSelected] = useState(null);
  const [optionAddress, setOptionAddress] = useState([]);
  const [totalAddressPages, setTotalAddressPages] = useState(0);
  const [addressQueries, setAddressQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
  });
  const [isEmpty, setIsEmpty] = useState(false);
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [loading, setLoading] = useState(false);
  const validateMessages = {
    required: t("validate.required"),
  };
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [isSkip, setIsSkip] = useState(false);

  // const providerOptions = [
  //   {
  //     label: t("channelProvider.sms"),
  //     value: CHANNEL_PROVIDER.SMS,
  //   },
  //   {
  //     label: t("channelProvider.mms"),
  //     value: CHANNEL_PROVIDER.MMS,
  //   },
  //   {
  //     label: t("channelProvider.whatsapp"),
  //     value: CHANNEL_PROVIDER.WhatsApp,
  //   },
  //   {
  //     label: t("channelProvider.voice"),
  //     value: CHANNEL_PROVIDER.Voice,
  //   },
  // ];

  const onFinish = async () => {
    const isWarning = await checkExtraService();
    if (isWarning) {
      setShowWarningModal(true);
    } else if (objectPrice.overNumber > 0) {
      setIsShowConfirmPopup(true);
    } else {
      doCheckout();
    }
  };
  const checkExtraService = async () => {
    let overNumber = false;
    if (
      currentSubscription?.downgrade &&
      currentSubscription?.downgradePackageId
    ) {
      const { payload } = await dispatch(
        doGetSubscriptionDetail(currentSubscription.downgradePackageId)
      );
      if (
        payload &&
        payload?.numberInc &&
        ((payload?.numberInc < subscriptionPackage?.numberInc &&
          payload?.numberInc <
            currentSubscription?.currentNumberOfAddress + 1) ||
          (payload?.numberInc === subscriptionPackage?.numberInc &&
            noOfElements + 1 > subscriptionPackage?.numberInc))
      ) {
        overNumber = true;
        if (
          payload?.numberInc < subscriptionPackage?.numberInc &&
          payload?.numberInc < currentSubscription?.currentNumberOfAddress + 1
        ) {
          setIsSkip(true);
        } else {
          setIsSkip(false);
        }
      }
    }
    return overNumber;
  };

  const doCheckout = async () => {
    setLoading(true);
    const fieldsValue = formRef.current.getFieldsValue();

    const params = {
      serviceStatus: ADDRESS_STATUS.ASSIGNED,
      workspaceId: authInfo.workspaceId,
      channelId: fieldsValue["channel"],
    };

    const { payload } = await dispatch(
      doUpdateAddressStatus({
        id: formRef.current.getFieldValue("address"),
        params,
      })
    );
    if (payload && payload.status === 200) {
      const serviceId = payload?.data?.id;
      if (serviceId) dispatch(setServiceId(serviceId));
      voiceSettingRef?.current?.submit();
      setIsShowConfirmPopup(false);
      setLoading(false);
      onSuccess();
    } else {
      setLoading(false);
      setIsShowConfirmPopup(false);
    }
  };

  const getAddressAvailableList = async request => {
    setLoadingList(true);
    const newRequest = {
      ...request,
    };
    if (request.isEmpty) {
      delete newRequest.isEmpty;
    }
    if (request.isReset) {
      setAvailableList([]);
      delete newRequest.isReset;
    }
    if (totalAddressPages > 0 && totalAddressPages < newRequest.pageNumber) {
      setLoadingList(false);
      return;
    }
    setLoadingAddress(true);
    const { payload } = await dispatch(doGetAddressAvailableList(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isEmpty) {
        if (payload.content && payload.content.length === 0) {
          setIsEmpty(true);
          setLoadingList(false);
        }
      }
      if (request.isReset) {
        setAvailableList(removeDuplicates([...payload.content]));
      } else {
        setAvailableList(
          removeDuplicates([...availableList, ...payload.content])
        );
      }
      setTotalAddressPages(payload.totalPages);
      setAddressQueries(newRequest);
    }
    setLoadingAddress(false);
    setLoadingList(false);
  };

  const handleSearch = key => {
    if (key) {
      getAddressAvailableList({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        address: key,
      });
    } else {
      getAddressAvailableList({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
      });
    }
  };

  const handleScroll = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      addressQueries.pageNumber <= totalAddressPages &&
      !loadingList
    ) {
      getAddressAvailableList({
        ...addressQueries,
        pageNumber: addressQueries.pageNumber + 1,
      });
    }
  };

  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };

  const renderAddressLabel = (address, protocols) => {
    const protocolList = Object.entries(protocols);

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span>{address}</span>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {protocolList.map(([key, value], index) => {
            return (
              <div
                key={index}
                style={{
                  marginRight: 12,
                }}
              >
                {value ? (
                  <CheckOutlined style={{ color: "#0E9154" }} />
                ) : (
                  <CloseOutlined style={{ color: "#E01839" }} />
                )}
                <span
                  style={{
                    marginLeft: 2,
                  }}
                >
                  {t("channelProvider." + key)}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (availableList && availableList?.length > 0) {
      const newOptions = availableList.map(item => {
        const { id, address, configuration } = item;
        return {
          key: id,
          label: renderAddressLabel(address, configuration),
        };
      });
      setOptionAddress(newOptions);
    } else {
      setOptionAddress([]);
    }
  }, [availableList]);

  const getListChannelByWorkspace = async () => {
    const { payload } = await dispatch(doGetAllChannel());
    return payload?.data;
  };

  const loadSubscriptionDetail = async () => {
    const { payload } = await dispatch(
      doGetSubscriptionDetail(currentSubscription.subscriptionPackageId)
    );
    if (payload) {
      setSubscriptionPackage(payload);
    }
  };

  const calculateTotalPrice = () => {
    const now = moment().utc();
    const startDate = moment(currentSubscription?.startTime).utc();
    const endDate = moment(currentSubscription?.endTime).utc();

    const currentTotalDays = moment(endDate).diff(moment(startDate), "days");
    let remainingDays = moment(endDate).diff(moment(now), "days");
    if (now.startOf("date").diff(startDate.startOf("date")) === 0) {
      remainingDays = currentTotalDays;
    }

    let overNumber = noOfElements + 1 > subscriptionPackage?.numberInc ? 1 : 0;
    overNumber = overNumber > 0 ? overNumber : 0;

    const costNumberPerUnit =
      currentTotalDays !== remainingDays
        ? subscriptionPackage?.numberFee / currentTotalDays
        : subscriptionPackage?.numberFee;
    const costNumberTotal =
      currentTotalDays === remainingDays
        ? costNumberPerUnit * overNumber
        : costNumberPerUnit?.toFixed(2) * overNumber * remainingDays;

    const gst = costNumberTotal !== 0 ? costNumberTotal?.toFixed(2) * 0.1 : 0;

    setObjectPrice({
      currentTotalDays: currentTotalDays,
      remainingDays: remainingDays,
      overNumber: overNumber,
      costNumberPerUnit: costNumberPerUnit,
      costNumberTotal: costNumberTotal,
      totalFee: costNumberTotal + gst,
      gst: gst,
    });
    return true;
  };

  useEffect(() => {
    dispatch(doGetUseSubscription());
    // setLoadingList(true);
    getAddressAvailableList({
      pageNumber: 1,
      pageSize: 10,
      isEmpty: true,
    });
    // setLoadingList(false);
    getListChannelByWorkspace().then(res => {
      const list = res
        .filter(item => item.status === CHANNEL_STATUS.ENABLED)
        .sort((a, b) => {
          return a.name.toLowerCase() < b.name.toLowerCase()
            ? -1
            : a.name.toLowerCase() > b.name.toLowerCase()
            ? 1
            : 0;
        })
        .map(item => {
          return {
            ...item,
            value: item.id,
            label:
              item.name === CHANNEL_NAME.BULKSMS
                ? t("channelName.BULKSMS")
                : item.name,
          };
        });
      setChannelList(list);
      setChannelLoading(false);
    });

    let timeoutId;

    timeoutId = setTimeout(() => {
      // // Embed a hubspot form in a service component
      const script = document.createElement("script");
      script.src = "https://js.hsforms.net/forms/embed/v2.js";
      document.body.appendChild(script);
      script.addEventListener("load", () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            region: "na1",
            portalId: "42843911",
            formId: "694b03dc-fc25-4a9f-804e-246eb9f18585",
            target: "#hubspotForm",
          });
          clearTimeout(timeoutId);
        }
      });
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    if (currentSubscription.subscriptionPackageId) {
      loadSubscriptionDetail();
    }
  }, [currentSubscription]);

  useEffect(() => {
    if (subscriptionPackage && noOfElements) {
      calculateTotalPrice();
    }
  }, [subscriptionPackage, noOfElements]);

  const handleTitleWarning = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <ExclamationCircleFilled style={{ color: "#faad14", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("payment.warning")}
        </span>
      </div>
    );
  };

  return (
    <div style={{ height: "100%" }}>
      {loadingList ? (
        <div style={{ margin: "30px", width: "100%", textAlign: "center" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Form
          ref={formRef}
          // layout={"vertical"}
          initialValues={() => {}}
          name={"nest-messages"}
          validateMessages={validateMessages}
          onFinish={onFinish}
        >
          {!isEmpty ? (
            <>
              <p
                style={{ ...numberFormStyle.labelTitle, marginBottom: "16px" }}
              >
                {t("numbers.note")}
              </p>

              <p style={numberFormStyle.labelTitle} className={styles.required}>
                {t("numbers.number")}
              </p>

              <Form.Item name="address" rules={[{ required: true }]}>
                <SelectSingle
                  type={"select-search"}
                  showSearch
                  allowClear={false}
                  optionFilterProp="children"
                  options={optionAddress}
                  onChange={value => {
                    // setServiceIdSelected(value);
                    formRef.current.setFieldsValue({
                      address: value,
                    });
                  }}
                  config={{
                    width: "100%",
                  }}
                  loading={loadingAddress}
                  handleSearch={handleSearch}
                  handleScroll={handleScroll}
                />
              </Form.Item>
              {/* {channelSelected && channelSelected.provider && (
                <>
                  <p style={numberFormStyle.labelTitle}>
                    {t("numbers.protocols")}
                  </p>
                  <Form.Item name="channelEnable">
                    <Checkbox.Group options={providerOptions}></Checkbox.Group>
                  </Form.Item>
                </>
              )} */}

              <p style={numberFormStyle.labelTitle}>{t("numbers.channel")}</p>
              <Form.Item name="channel">
                <AppSelect
                  loading={channelLoading}
                  disabled={channelLoading}
                  showSearch
                  optionFilterProp="children"
                  isFilterOption={true}
                  isFilterSort={true}
                  options={channelList}
                  onChange={value => {
                    const item =
                      channelList?.find(item => item.id === value) || null;
                    // setChannelSelected(item);
                    formRef.current.setFieldsValue({
                      channel: value,
                    });
                    let channelEnable = [];
                    if (item) {
                      Object.entries(item.provider).forEach(([key, value]) => {
                        if (value) {
                          switch (key) {
                            case CHANNEL_PROVIDER.SMS:
                              channelEnable.push(CHANNEL_PROVIDER.SMS);
                              break;
                            case CHANNEL_PROVIDER.MMS:
                              channelEnable.push(CHANNEL_PROVIDER.MMS);
                              break;
                            case CHANNEL_PROVIDER.WhatsApp.toLowerCase():
                              channelEnable.push(CHANNEL_PROVIDER.WhatsApp);
                              break;
                            case CHANNEL_PROVIDER.Voice.toLowerCase():
                              channelEnable.push(CHANNEL_PROVIDER.Voice);
                              break;
                          }
                        }
                      });
                    }
                    formRef.current.setFieldsValue({
                      channelEnable: channelEnable,
                    });
                  }}
                />
              </Form.Item>

              {/*  {channelSelected && channelSelected.provider && (
                <>
                  <p style={numberFormStyle.labelTitle}>
                    {t("numbers.servicesEnable")}
                  </p>
                  <Form.Item name="channelEnable">
                    <Checkbox.Group
                      options={providerOptions}
                      // onChange={handleShowVoiceSetting}
                    ></Checkbox.Group>
                  </Form.Item>
                </>
              )}
                */}
              {/* {isShowVoiceSetting && (
                <VoiceSetting
                  ref={voiceSettingRef}
                  serviceIdSelected={serviceIdSelected}
                />
              )} */}
            </>
          ) : noOfElements > 0 ? (
            <>
              <div id="hubspotForm"></div>
            </>
          ) : (
            <p
              dangerouslySetInnerHTML={{
                __html: t("numbers.noAvailableNumberJoinWaitlist"),
              }}
            ></p>
          )}
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              justifyContent: "end",
              gap: "16px",
            }}
          >
            <AppButton
              label={t("button.cancel")}
              color={"grey"}
              htmlType="button"
              loading={loading}
              onClick={() => {
                onCancel();
              }}
            />
            {availableList.length > 0 && (
              <AppButton
                label={t("button.assign")}
                color={"blue"}
                type="primary"
                htmlType="submit"
                loading={loading}
              />
            )}
          </div>
        </Form>
      )}

      <ModalForm
        title={t("payment.checkoutExtraServices")}
        onCancel={() => setIsShowConfirmPopup(false)}
        destroyOnClose={true}
        isOpen={isShowConfirmPopup}
        labelSubmit={t("label.save")}
        customWidth={600}
        footer={false}
        maskClosable={false}
      >
        <Row gutter={[20, 8]}>
          <Col span={12}>{t("payment.noExtraNumbers")}</Col>
          <Col span={12} style={numberFormStyle.textAlignRight}>
            <Typography.Text strong>
              {objectPrice?.overNumber?.toLocaleString()}
            </Typography.Text>
          </Col>
          <Col span={12}>
            {t("payment.price")}
            {objectPrice?.currentTotalDays !== objectPrice?.remainingDays &&
              t("payment.perDay")}
          </Col>
          <Col span={12} style={numberFormStyle.textAlignRight}>
            <Typography.Text strong>
              {"AUD" +
                objectPrice?.costNumberPerUnit?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
            </Typography.Text>
          </Col>
          <Col span={12}>{t("payment.subtotal")}</Col>
          <Col span={12} style={numberFormStyle.textAlignRight}>
            <Typography.Text strong>
              {"AUD" +
                objectPrice?.costNumberTotal?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
            </Typography.Text>
          </Col>
          <Col span={12}>{t("payment.gst")}</Col>
          <Col span={12} style={numberFormStyle.textAlignRight}>
            <Typography.Text strong>
              {"AUD" +
                objectPrice?.gst?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
            </Typography.Text>
          </Col>

          <Col span={12}>{t("payment.subscriptionPackage")}</Col>
          <Col
            span={12}
            style={{ ...numberFormStyle.textAlignRight, fontWeight: "bold" }}
          >
            {subscriptionPackage.name}
          </Col>
          <Col span={12}>{t("payment.totalCost")}</Col>
          <Col
            span={12}
            style={{ ...numberFormStyle.textAlignRight, fontWeight: "bold" }}
          >
            {"AUD" +
              objectPrice?.totalFee?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
          </Col>
          <Col span={12}>{t("payment.card")}</Col>
          <Col
            span={12}
            style={{ ...numberFormStyle.textAlignRight, fontWeight: "bold" }}
          >
            {workspaceDetail.cardHolder}
            {"  "}
            ****{workspaceDetail.stripLast4Digit}
          </Col>
        </Row>
        <div style={{ width: "100%", marginTop: 16 }}>
          <AppButton
            label={
              t("payment.pay") +
              " " +
              "AUD" +
              objectPrice?.totalFee?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })
            }
            style={{ width: "100%" }}
            size="small"
            color={"primary"}
            type="submit"
            loading={loading}
            onClick={doCheckout}
          />
        </div>
      </ModalForm>
      <ModalForm
        title={handleTitleWarning()}
        onCancel={() => setShowWarningModal(false)}
        destroyOnClose={true}
        isOpen={showWarningModal}
        customWidth={600}
        maskClosable={false}
        footer={[
          <AppButton
            key="button-cancel"
            label={t("button.cancel")}
            color={"grey"}
            htmlType="button"
            onClick={() => {
              setShowWarningModal(false);
            }}
          />,
          <AppButton
            key="button-continue"
            label={t("button.continue")}
            color={"blue"}
            htmlType="button"
            onClick={() => {
              setShowWarningModal(false);
              if (isSkip) {
                doCheckout();
              } else {
                setIsShowConfirmPopup(true);
              }
            }}
          />,
        ]}
      >
        {t("payment.warningExtraService")}
      </ModalForm>
    </div>
  );
};
const numberFormStyle = {
  labelTitle: {
    fontWeight: "bold",
    marginBottom: "6px",
  },
  lineHeightLg: {
    lineHeight: "1.2rem",
  },
  appearBox: {
    backgroundColor: "#F9FAFB",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "16px",
  },
  textAlignRight: {
    textAlign: "right",
  },
};
export default NumberOperatorAssignForm;
